import React, { useState } from "react";
import { Container } from "./styles";
import { Link, useLocation } from "react-router-dom";
import { useUserContext } from "../contexts/useUserContext";
import logo from "../../assets/logo.png";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { BiSearchAlt2 } from "react-icons/bi";
import { FaBars } from "react-icons/fa";
import { FiLogIn, FiLogOut, FiArrowRightCircle } from "react-icons/fi";
import { IconContext } from "react-icons";

export const Navbar = () => {
  const { user, sign_out } = useUserContext();
  const location = useLocation();

  const [userBar, setUserBar] = useState(false);
  const showUserBar = () => {
    setUserBar(!userBar);
  };

  const [dropdown, setDropdown] = useState(false);
  const showDropdown = () => {
    setDropdown(!dropdown);
  };

  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => {
    setSidebar(!sidebar);
  };
  return (
    <Container home={location.pathname === "/"}>
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="logomarca da página" />
        </Link>
      </div>
      <div className="middle">
        <Link to="/" className={location.pathname === "/" ? "current-item" : "other-itens"}>
          Início
        </Link>
        <Link
          to="/tutorial"
          className={location.pathname === "/tutorial" ? "current-item" : "other-itens"}
        >
          Como Adquirir suas Férias
        </Link>
        <Link
          to="/destination1"
          className={location.pathname === "/destination1" ? "current-item" : "other-itens"}
        >
          Marcar Férias
        </Link>
        <Link
          to="/contacts"
          className={location.pathname === "/contacts" ? "current-item" : "other-itens"}
        >
          Contato
        </Link>
        <Link 
          to='/revendedor/seja' 
          className={location.pathname === '/revendedor/seja' ? "current-item" : "other-itens"}
        >
          Seja um Revendedor
        </Link>
      </div>
      {user ? (
        <div className="header-login">
          <span onClick={showUserBar}>Bem-vindo, {user.name}!</span>
        </div>
      ) : (
        <div className="header-login">
          <button>
            <BiSearchAlt2 className="src-icon" />
          </button>
          <Link to="/login">
            <button>Entrar</button>
          </Link>
          <Link to="/sign_up">
            <button className="reg-buttom">Criar Conta</button>
          </Link>
        </div>
      )}
      <IconContext.Provider value={{ color: "#f5f5f5", size: "30px" }}>
        <span className="menu-bars">
          <FaBars onClick={showSidebar} />
        </span>
        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items">
            <li className="navbar-toggle" onClick={showSidebar}>
              <span className="menu-bars">
                <FiArrowRightCircle />
              </span>
            </li>

            {user ? (
              <li className="nav-text">
                <Link to="#" onClick={showDropdown}>
                  <span>Bem vindo, {user.name}</span>
                  {dropdown ? <AiFillCaretUp /> : <AiFillCaretDown />}
                </Link>
              </li>
            ) : (
              ""
            )}

            <div className={dropdown ? "drop drop-active" : "drop"}>
              {user && user.type === "admin" ? (
                <li className="nav-text">
                  <Link to="/admindashboard">
                    <p>Dashboard do Admin</p>
                  </Link>
                </li>
              ) : (
                ""
              )}

              {user && user.type === "retailer" ? (
                <li className="nav-text">
                  <Link to="/retailersdashboard">
                    <p>Dashboard do revendedor</p>
                  </Link>
                </li>
              ) : (
                ""
              )}
              <li className="nav-text">
                <Link to="/profile" onClick={showSidebar}>
                  <span>Meu Perfil</span>
                </Link>
              </li>
              
              {user && user.type === "client" ? (
                <>
                <li className='nav-text'>
                  <Link to='#' onClick={showSidebar}>
                    <span>Solicitações de reserva</span>
                  </Link>
                </li>
                <li className='nav-text'>
                  <Link to='#' onClick={showSidebar}>
                    <span>Histórico de pedidos</span>
                  </Link>
                </li>
                </>
              ) : (
                ""
              )}
            </div>

            <li className="nav-text" onClick={showSidebar}>
              <Link to="/">
                <span>Início</span>
              </Link>
            </li>
            <li className="nav-text" onClick={showSidebar}>
              <Link to="#">
                <span>Como Adquirir suas Férias</span>
              </Link>
            </li>
            <li className="nav-text" onClick={showSidebar}>
              <Link to="#">
                <span>Marcar Férias</span>
              </Link>
            </li>
            <li className="nav-text" onClick={showSidebar}>
              <Link to="/contacts">
                <span>Contato</span>
              </Link>
            </li>
            <li className='nav-text' onClick={showSidebar}>
              <Link to='/revendedor/seja'>
                <span>Seja um Revendedor</span>
              </Link>
            </li>

            {user ? (
              <li className="nav-text" onClick={showSidebar}>
                <Link to="/" className="header-login" onClick={sign_out}>
                  <FiLogIn />
                  <span> Logout </span>
                </Link>
              </li>
            ) : (
              <li className="nav-text" onClick={showSidebar}>
                <Link className="header-login" to="/login">
                  <FiLogOut />
                  <span> Login </span>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </IconContext.Provider>
      <div className={userBar ? "arrow-up active" : "arrow-up"}></div>
      <nav className={userBar ? "nav-user active" : "nav-user"}>
        <ul className="user-menu-items">
          {user && user.type === "admin" ? (
            <li className="user-text">
              <Link to="/admindashboard" onClick={showUserBar}>
                <p>Dashboard do Admin</p>
              </Link>
            </li>
          ) : (
            ""
          )}
          {user && user.type === "retailer" ? (
            <li className="user-text">
              <Link to="/retailersdashboard" onClick={showUserBar}>
                <p>Dashboard do Revendedor</p>
              </Link>
            </li>
          ) : (
            ""
          )}

          <li className="user-text">
            <Link to="/profile" onClick={showUserBar}>
              <p>Meu perfil</p>
            </Link>
          </li>

          {user && user.type === "client" ? (
            <>
            <li className='user-text'>
              <Link to='#' onClick={showUserBar}>
                <p>Solicitações de reserva</p>
              </Link>
            </li>
            <li className='user-text'>
              <Link to='#' onClick={showUserBar}>
                <p>Histórico de pedidos</p>
              </Link>
            </li>
            </>
          ) : (
            ""
          )}

          <li className="user-text logout">
            <p onClick={sign_out}>Sair</p>
          </li>
        </ul>
      </nav>
    </Container>
  );
};
